import React from 'react';
import { Icon, Button } from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../../translate/II18';
import {
  POSITION_INSIDE,
  POSITION_OUTSIDE_BOTTOM,
  POSITION_OUTSIDE_TOP
} from '../../helpers/utils';
import {
  FORMELEMENTS_ACCEPT_BUTTON,
  FORMELEMENTS_CHECKBOXES,
  FORMELEMENTS_DATEPICKER,
  FORMELEMENTS_DROPDOWN,
  FORMELEMENTS_RADIOBUTTONS,
  FORMELEMENTS_SIGNATURE,
  FORMELEMENTS_TIMEPICKER
} from '../../FormBuilder/FormElements';

const NAV_BUTTON_START = 0;
const NAV_BUTTON_NEXT = 1;
const NAV_BUTTON_EDIT = 2;
const NAV_BUTTON_DONE = 3;

function navButtonTitle(navButtonState, formElementType, err, doneTitleKey) {
  if (err && err.errType) {
    return 'common_error';
  }
  switch (navButtonState) {
    case NAV_BUTTON_NEXT:
      return 'title_next';
    case NAV_BUTTON_EDIT:
      switch (formElementType) {
        case FORMELEMENTS_DROPDOWN:
        case FORMELEMENTS_RADIOBUTTONS:
        case FORMELEMENTS_CHECKBOXES:
        case FORMELEMENTS_DATEPICKER:
        case FORMELEMENTS_TIMEPICKER:
          return 'title_select';
        case FORMELEMENTS_ACCEPT_BUTTON:
          return 'title_confirm';
        case FORMELEMENTS_SIGNATURE:
          return 'forms_sign';
        default:
          return 'title_fillin';
      }
    case NAV_BUTTON_DONE:
      return doneTitleKey || 'title_done';
    default:
      return 'title_start';
  }
}

function PdfNavButton(props) {
  const {
    btnId,
    asEditHere,
    fixed,
    visible,
    topPosition,
    topMargin,
    title,
    icon,
    navButtonClick
  } = props;

  return (
    <Button
      fill
      id={btnId}
      className={asEditHere ? 'asEditHere' : ''}
      style={{
        position: fixed ? 'fixed' : 'absolute',
        opacity: visible ? 1 : 0,
        top: topPosition,
        marginTop: topMargin
      }}
      onClick={() => navButtonClick()}
    >
      <>
        {icon}
        {II18.get(title)}
      </>
    </Button>
  );
}

PdfNavButton.propTypes = {
  navButtonClick: PropTypes.func,
  icon: PropTypes.object,
  title: PropTypes.string,
  btnId: PropTypes.string,
  topMargin: PropTypes.number,
  topPosition: PropTypes.any,
  visible: PropTypes.bool,
  fixed: PropTypes.bool,
  asEditHere: PropTypes.bool
};

export const PdfElementsNavigation = props => {
  const {
    navMarkerButtonSlideTopPosition,
    navMarkerButtonTopPosition,
    navMarkerButtonElementError,
    navMarkerButtonElementType,
    navMarkerButtonVisible,
    formValid,
    formActionTitleKey,
    treatAsStarted,
    pageScrolledAfterDone,
    navGoToNextButtonElementType,
    navGoToNextButtonElementError,
    nextElementLocation,
    navGoToNextButtonSlideTopPosition,
    navGoToNextButtonTopPosition,
    navButtonClick,
    noStartButtonMode
  } = props;

  const navGoToNextButtonTopLocation =
    nextElementLocation === POSITION_OUTSIDE_TOP;
  const navGoToNextButtonBottomLocation =
    nextElementLocation === POSITION_OUTSIDE_BOTTOM;
  const navGoToNextButtonAsMarker = nextElementLocation === POSITION_INSIDE;

  const navMarkerButtonState = formValid
    ? NAV_BUTTON_DONE
    : treatAsStarted
    ? navMarkerButtonElementError
      ? NAV_BUTTON_EDIT
      : NAV_BUTTON_NEXT
    : NAV_BUTTON_START;

  const navGoToNextButtonState = navGoToNextButtonAsMarker
    ? NAV_BUTTON_EDIT
    : NAV_BUTTON_NEXT;

  const navMarkerButtonTitle = navButtonTitle(
    noStartButtonMode && navMarkerButtonState === NAV_BUTTON_START
      ? NAV_BUTTON_NEXT
      : navMarkerButtonState,
    navMarkerButtonElementType,
    navMarkerButtonElementError,
    formActionTitleKey
  );
  const navGoToNextButtonTitle =
    navGoToNextButtonElementType &&
    navButtonTitle(
      navGoToNextButtonState,
      navGoToNextButtonElementType,
      navGoToNextButtonElementError
    );

  const navMarkerButtonDoneMode = navMarkerButtonState === NAV_BUTTON_DONE;
  const navMarkerButtonEditMode = navMarkerButtonState === NAV_BUTTON_EDIT;

  const navMarkerButtonIcon =
    !noStartButtonMode && !treatAsStarted && !navMarkerButtonDoneMode ? (
      <Icon ios="f7:play_fill" md="material:play_arrow" />
    ) : navMarkerButtonDoneMode ? (
      <Icon material={'done'} />
    ) : null;

  const navGoToNextIcon = navGoToNextButtonBottomLocation ? (
    <Icon material={'arrow_downward'} />
  ) : navGoToNextButtonTopLocation ? (
    <Icon material={'arrow_upward'} />
  ) : null;

  return (
    <>
      <PdfNavButton
        btnId={'btnNavMarker'}
        asEditHere={navMarkerButtonEditMode}
        fixed={pageScrolledAfterDone}
        visible={navMarkerButtonVisible || pageScrolledAfterDone}
        topPosition={
          pageScrolledAfterDone ? '50%' : navMarkerButtonSlideTopPosition
        }
        topMargin={
          pageScrolledAfterDone
            ? 0
            : treatAsStarted
            ? navMarkerButtonTopPosition
            : 60
        }
        title={navMarkerButtonTitle}
        icon={navMarkerButtonIcon}
        navButtonClick={navButtonClick}
      />

      {!navMarkerButtonVisible &&
        !pageScrolledAfterDone &&
        navGoToNextButtonElementType && (
          <PdfNavButton
            btnId={'btnNavNext'}
            asEditHere={navGoToNextButtonAsMarker}
            fixed={!navGoToNextButtonAsMarker}
            visible={true}
            topPosition={
              navGoToNextButtonAsMarker
                ? navGoToNextButtonSlideTopPosition
                : navGoToNextButtonTopLocation
                ? '10%'
                : '85%'
            }
            topMargin={
              navGoToNextButtonAsMarker ? navGoToNextButtonTopPosition : 0
            }
            title={navGoToNextButtonTitle}
            icon={navGoToNextIcon}
            navButtonClick={navButtonClick}
          />
        )}
    </>
  );
};

PdfElementsNavigation.propTypes = {
  navMarkerButtonSlideTopPosition: PropTypes.number,
  navMarkerButtonTopPosition: PropTypes.number,
  navMarkerButtonElementError: PropTypes.any,
  navMarkerButtonElementType: PropTypes.string,
  navMarkerButtonVisible: PropTypes.bool,
  noStartButtonMode: PropTypes.bool,
  formValid: PropTypes.bool,
  formActionTitleKey: PropTypes.string,
  treatAsStarted: PropTypes.bool,
  pageScrolledAfterDone: PropTypes.bool,
  navGoToNextButtonElementType: PropTypes.any,
  navGoToNextButtonElementError: PropTypes.any,
  nextElementLocation: PropTypes.number,
  navGoToNextButtonSlideTopPosition: PropTypes.any,
  navGoToNextButtonTopPosition: PropTypes.number,
  navButtonClick: PropTypes.func
};
